/**
 * Remove trailing slashes from the given `str`
 *
 * @api public
 * @param {String} str
 * @return {String}
 */
exports = module.exports = function (str) {
  return String(str).replace(exports.expr, '');
};
/**
 * Expose the regex
 *
 * @api private
 * @type {RegExp}
 */


exports.expr = /\/+$/;